import React, { useEffect, useState } from 'react';
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { NumericFormat } from 'react-number-format';

function ControlledNumericFormat({
    value: propValue,
    onValueChange,
    ...props
  }) {
    
    const [localValue, setLocalValue] = useState(propValue);

    useEffect(() => {
        console.log('here prop and local value', propValue, localValue)
      if (propValue !== localValue) {
        setLocalValue(propValue);
      }
    }, [propValue, localValue]);
  
    function handleChange(values) {
      onValueChange(values);
      setLocalValue(values.floatValue);  //   <-- this commented shouldn't allow input changes
    }
  
    return (
    //   <NumericFormat value={localValue} onValueChange={handleChange} {...props} />
      <NumericFormat 
        value={localValue}
        onValueChange={(values) => {
            handleChange(values)
        }}
        // disabled={form._id}
        decimalScale={0}
        allowLeadingZeros={false}
        allowedDecimalSeparators={false}
        allowNegative={false}
        thousandSeparator
        customInput={TCInput}
        {...props}
        />
    );
}

export default ControlledNumericFormat